import { Component, OnInit, ViewChild, Input, OnChanges } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog, MatDialogConfig } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { RequestDetailEvaluator } from '../shared/request-detail-evaluator.model';
import { MoreDetailDialogComponent } from '../more-detail-dialog/more-detail-dialog.component';

@Component({
  selector: 'app-request-detail-evaluator',
  templateUrl: './request-detail-evaluator.component.html',
  styleUrls: ['./request-detail-evaluator.component.scss']
})
export class RequestDetailEvaluatorComponent implements OnInit, OnChanges {

  aprobada = '7.7';
  aprobadaLabel = 'Aprobada';
  reprobada = '8.8';
  reprobadaLabel = 'Reprobada';
  displayedColumns: string[] = ['select', 'fecha', 'cedula', 'codigo', 'materia',
                                'institucion', 'periodo', 'nota', 'vermas'];
  dataSource: MatTableDataSource<RequestDetailEvaluator>;
  selection = new SelectionModel<RequestDetailEvaluator>(true, []);

  @Input() requestDetail: RequestDetailEvaluator[];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private dialog: MatDialog) {

  }

  ngOnInit() {
    this.dataSource = new MatTableDataSource<RequestDetailEvaluator>(this.requestDetail);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  ngOnChanges() {
    this.dataSource = new MatTableDataSource<RequestDetailEvaluator>(this.requestDetail);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  evaluate(row: RequestDetailEvaluator) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data =  { intensidad: row.intensidadHoraria,
      creditos: row.numeroCreditos,
      comentarios: row.comentario};
    dialogConfig.width = '40%';
    const dialogRef = this.dialog.open(MoreDetailDialogComponent, dialogConfig);
  }

  getScore(nota) {
    if (nota ===  this.aprobada) {
      return this.aprobadaLabel;
    } else if (nota === this.reprobada) {
      return this.reprobadaLabel;
    } else {
      return nota;
    }
}
}
